export default "__VITE_ASSET__f3cf6098__"